import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatDialog } from "@angular/material/dialog";
import { NavigationStart, Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { filter, switchMap } from "rxjs";
import { isExpiredAuth0RefreshTokenError } from "./common/errorUtils";
import { AccountService } from "./services/infra/account/account.service";
import { UserService } from "./services/infra/user/user.service";

@Component({
    selector: "app-root",
    template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
    private _accountService = inject(AccountService);
    private _destroyRef = inject(DestroyRef);

    constructor(
        public router: Router,
        private _matDialog: MatDialog,
        public auth: AuthService,
        private _userService: UserService,
    ) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this._matDialog.closeAll();
            }
        });

        this._subscribeToExpiredAuth0RefreshTokenError();
    }

    ngOnInit() {
        this._accountService.getAccountDetails$().pipe(takeUntilDestroyed(this._destroyRef)).subscribe();
    }

    private _subscribeToExpiredAuth0RefreshTokenError() {
        this.auth.isAuthenticated$
            .pipe(
                filter((isAuthenticated) => isAuthenticated),
                switchMap(() => this.auth.error$),
                filter(isExpiredAuth0RefreshTokenError),
                takeUntilDestroyed(this._destroyRef),
            )
            .subscribe(() => {
                if (this._userService.loggedInUser) {
                    this.auth.loginWithRedirect();
                }
            });
    }
}
